export default __webpack_public_path__ + "static/media/layer4.0a5b9ec9.svg";